export const DOMAIN = 'http://54.207.206.5:9000' 
export const DOMAINmylims = 'http://54.207.206.5:9001'
//export const DOMAIN = 'http://localhost:3333'
 